import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Question from '../../../views/ProductDetails/Series3CollarDetails/components/FAQ/Question';
import styles from './MiniFAQ.module.scss';
import { ReactComponent as IconHelp } from '../../../assets/images/icons/icon_help.svg';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { showNanoVariant } from '../../../components/NanoBanner/NanoBanner';
import { closeDecagonChat, openDecagonChat } from '../../../components/AppBar/NavBar';
import { series3CollarFAQChatButtonClick } from '../../../lib/analytics/events';
import classNames from 'classnames';

export default function VerizonMiniFAQ({ containerRef }: { containerRef?: React.RefObject<HTMLDivElement> }) {
  const { t } = useTranslation();
  const decagonChatEnabled = useFeatureValue('decagon-chat-widget', false);
  const showDecagonChat = showNanoVariant() && decagonChatEnabled;

  useEffect(() => {
    const handleMessage = (event: any) => {
      if (event.origin !== 'https://decagon.ai') return;

      const { data } = event;
      if (data.type === 'DECAGON_INACTIVE') {
        closeDecagonChat();
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
      // Close the chat when navigating away
      closeDecagonChat();
    };
  }, []);

  return (
    <div ref={containerRef} className={classNames(styles.container, styles.verizonContainer)}>
      <h2 className={styles.heading}>{t('faq')}</h2>
      <div>
        <Question title={t('what_is_the_fi_mini')} page="Mini" index={0}>
          {t('what_is_the_fi_mini_answer')}
        </Question>
        <Question title={t('how_does_fi_mini_work_with_the_verizon_family_app')} page="Mini" index={1}>
          {t('how_does_fi_mini_work_with_the_verizon_family_app_answer')}
        </Question>
        <Question title={t('what_special_offer_do_verizon_customers_get')} page="Mini" index={2}>
          {t('what_special_offer_do_verizon_customers_get_answer', { amount: 10 })}
        </Question>
        <Question title={t('is_the_fi_mini_only_for_dogs')} page="Mini" index={3}>
          {t('is_the_fi_mini_only_for_dogs_answer')}
        </Question>
        <Question title={t('how_do_i_activate_my_fi_mini')} page="Mini" index={6}>
          {t('how_do_i_activate_my_fi_mini_answer')}
        </Question>
        <Question title={t('how_do_i_contact_support')} page="Mini" index={7}>
          <ul>
            <li>{t('verizon_support_fi_device_contact')}</li>
            <li>{t('verizon_support_family_app_contact')}</li>
          </ul>
        </Question>
      </div>
      {showDecagonChat && (
        <div className={styles.decagonChatContainer}>
          <IconHelp />
          <div className={styles.decagonChatTitle}>{t('something_else_on_your_mind')}</div>
          <button
            className={styles.decagonChatButton}
            onClick={() => {
              series3CollarFAQChatButtonClick();
              openDecagonChat();
            }}
          >
            {t('chat_with_fi')}
          </button>
        </div>
      )}
    </div>
  );
}
